export default __webpack_public_path__ + "static/media/image 2.c985e63f.svg";